// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__nNHSr","footer":"ModalFilter_footer__moBGA"};